import React from 'react';
import { ElementsConsumer, CardElement } from '@stripe/react-stripe-js';

class StripeTestCardElement extends React.Component {
  handleSubmit = async (event) => {
    // We don't want to let default form submission happen here,
    // which would refresh the page.
    event.preventDefault();

    const { stripe, elements } = this.props;

    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }
    var cl = this.props.elements.getElement(CardElement)


    const result = await stripe.createToken(cl);
    
    if (result.error) {
      // Show error to your customer (for example, payment details incomplete)
    } else {
      // Your customer will be redirected to your `return_url`. For some payment
      // methods like iDEAL, your customer will be redirected to an intermediate
      // site first to authorize the payment, then redirected to the `return_url`.
    }
  };

  render() {
    return (
      <form onSubmit={this.handleSubmit}>
        <CardElement />
        <button disabled={!this.props.stripe}>Submit</button>
      </form>
    );
  }
}

export default function InjectedCheckoutForm(stripe ,elements) {
  return (
    // <ElementsConsumer>
    //   {({ stripe, elements }) => (
        <StripeTestCardElement stripe={stripe} elements={elements} />
      // )}
    // </ElementsConsumer>
  )
}